/*
  Good-Natured Kollektions-Reihen (13.10.2026)
  Gehoert zu sections/featured-collection.liquid ("Vorgestellte Kollektion").

  - Endlos-Karussell: kommt man ans Ende der Reihe, werden weitere
    Produkte derselben Kollektion nachgeladen - so lange, bis die
    Kollektion leer ist. Am Handy per Wischen, am Rechner per Pfeil.
  - Nachgeladen wird ueber templates/collection.gn-karten.liquid
    (12 Kacheln pro Abruf). Doppelte Produkte werden uebersprungen.
  - Am Rechner Pfeile links/rechts ueber den Bildern.
  - Am Handy auf Wunsch ein Fortschrittsbalken statt der Punkte,
    weil sich Punkte bei einer offenen Anzahl nicht sinnvoll zaehlen lassen.
*/
(function () {
  'use strict';
  if (window.gnKollektionsreihe) return;
  window.gnKollektionsreihe = true;

  var vorschau = '';
  try {
    if (window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main' && Shopify.theme.id) {
      vorschau = '&preview_theme_id=' + Shopify.theme.id;
    }
  } catch (e) {}

  var reihen = [];

  function handleVon(li) {
    var a = li.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var h = (a.getAttribute('href') || '').split('?')[0].split('#')[0];
    return h.split('/products/').pop().replace(/\/$/, '');
  }

  function rest(st) {
    var u = st.ul;
    return u.scrollWidth - u.scrollLeft - u.clientWidth;
  }

  function aktualisieren(st) {
    var u = st.ul;
    if (st.zurueck) st.zurueck.hidden = u.scrollLeft < 4;
    if (st.weiter) st.weiter.hidden = st.fertig && rest(st) < 4;
    if (st.balken) {
      var sw = u.scrollWidth || 1;
      st.balken.style.width = Math.min(100, (u.clientWidth / sw) * 100) + '%';
      st.balken.style.left = Math.max(0, (u.scrollLeft / sw) * 100) + '%';
    }
  }

  function vermessen(st) {
    var li = st.ul.querySelector('.grid__item');
    if (!li || !st.sc) return;
    var bild = li.querySelector('.card__inner') || li;
    var oben = bild.getBoundingClientRect().top - st.sc.getBoundingClientRect().top;
    st.sc.style.setProperty('--gn-pfeil-top', Math.round(oben + bild.offsetHeight / 2) + 'px');
    var fuge = parseFloat(window.getComputedStyle(st.ul).columnGap);
    if (!isNaN(fuge)) st.sc.style.setProperty('--gn-fuge', fuge + 'px');
  }

  function umbenennen(knoten, id) {
    var alle = [knoten].concat(Array.prototype.slice.call(knoten.querySelectorAll('[id], [aria-labelledby], [for]')));
    alle.forEach(function (el) {
      ['id', 'aria-labelledby', 'for'].forEach(function (attr) {
        var v = el.getAttribute && el.getAttribute(attr);
        if (v && v.indexOf('gn-karten') > -1) el.setAttribute(attr, v.split('gn-karten').join(id));
      });
    });
  }

  function laden(st) {
    if (st.fertig) return Promise.resolve(false);
    if (st.laedt) return st.laedt;
    var url = st.basis + (st.basis.indexOf('?') > -1 ? '&' : '?') + 'view=gn-karten&page=' + st.seite + vorschau;
    st.laedt = fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        st.laedt = null;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var box = doc.querySelector('[data-gn-karten]');
        if (!box) {
          st.fertig = true;
          aktualisieren(st);
          return false;
        }
        var neu = 0;
        Array.prototype.forEach.call(box.children, function (li) {
          var k = handleVon(li);
          if (!k || st.gesehen[k]) return;
          st.gesehen[k] = 1;
          var kopie = document.importNode(li, true);
          umbenennen(kopie, st.id);
          st.ul.appendChild(kopie);
          neu++;
        });
        st.seite++;
        if (box.getAttribute('data-gn-weiter') !== 'true') st.fertig = true;
        aktualisieren(st);
        if (!neu && !st.fertig) return laden(st);
        return neu > 0;
      })
      .catch(function (err) {
        st.laedt = null;
        st.fertig = true;
        aktualisieren(st);
        if (window.console) console.warn('[gn-kollektionsreihe] Nachladen gestoppt:', err);
        return false;
      });
    return st.laedt;
  }

  function knapp(st) {
    if (!st.fertig && rest(st) < st.ul.clientWidth * 1.5) laden(st);
  }

  function schrittweite(st) {
    if (st.schritt === 'eins') {
      var li = st.ul.querySelector('.grid__item');
      var fuge = parseFloat(window.getComputedStyle(st.ul).columnGap) || 0;
      return li ? li.getBoundingClientRect().width + fuge : st.ul.clientWidth;
    }
    return st.ul.clientWidth;
  }

  function einrichten(ul) {
    if (ul.gnFc) return;
    var basis = ul.getAttribute('data-gn-url');
    if (!basis) return;
    var sc = ul.closest('slider-component') || ul.parentNode;
    var st = {
      ul: ul,
      sc: sc,
      id: ul.getAttribute('data-id') || 'gn',
      basis: basis,
      seite: 1,
      fertig: ul.getAttribute('data-gn-mehr') !== 'true',
      laedt: null,
      gesehen: {},
      schritt: ul.getAttribute('data-gn-schritt') || 'reihe'
    };
    ul.gnFc = st;
    reihen.push(st);

    Array.prototype.forEach.call(ul.children, function (li) {
      var k = handleVon(li);
      if (k) st.gesehen[k] = 1;
    });

    st.zurueck = sc.querySelector('.gn-fc-pfeil--zurueck');
    st.weiter = sc.querySelector('.gn-fc-pfeil--weiter');

    if (ul.getAttribute('data-gn-fortschritt') === 'true') {
      var leiste = document.createElement('div');
      leiste.className = 'gn-fc-fortschritt';
      leiste.setAttribute('aria-hidden', 'true');
      st.balken = document.createElement('span');
      leiste.appendChild(st.balken);
      sc.appendChild(leiste);
    }

    if (st.weiter) {
      st.weiter.addEventListener('click', function () {
        var s = schrittweite(st);
        var los = function () {
          st.ul.scrollBy({ left: s, behavior: 'smooth' });
        };
        if (!st.fertig && rest(st) < s + 4) {
          laden(st).then(los);
        } else {
          los();
        }
      });
    }
    if (st.zurueck) {
      st.zurueck.addEventListener('click', function () {
        st.ul.scrollBy({ left: -schrittweite(st), behavior: 'smooth' });
      });
    }

    var rahmen = null;
    ul.addEventListener(
      'scroll',
      function () {
        if (rahmen) return;
        rahmen = requestAnimationFrame(function () {
          rahmen = null;
          aktualisieren(st);
          knapp(st);
        });
      },
      { passive: true }
    );

    /* Erste Nachlieferung schon holen, bevor die Reihe ins Bild kommt -
       damit am Rechner hinter dem Pfeil sofort etwas wartet. */
    if (!st.fertig) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(
          function (eintraege) {
            if (!eintraege[0].isIntersecting) return;
            io.disconnect();
            laden(st);
          },
          { rootMargin: '400px 0px' }
        );
        io.observe(ul);
      } else {
        laden(st);
      }
    }

    vermessen(st);
    aktualisieren(st);
  }

  function alleEinrichten() {
    Array.prototype.forEach.call(document.querySelectorAll('ul[data-gn-url]'), einrichten);
  }

  function alleVermessen() {
    reihen.forEach(function (st) {
      if (!st.ul.isConnected) return;
      vermessen(st);
      aktualisieren(st);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', alleEinrichten);
  } else {
    alleEinrichten();
  }
  window.addEventListener('load', alleVermessen);
  var uhr = null;
  window.addEventListener('resize', function () {
    clearTimeout(uhr);
    uhr = setTimeout(alleVermessen, 150);
  });
  document.addEventListener('shopify:section:load', alleEinrichten);
})();